import styled from 'styled-components';

export const Card = styled.div`
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  background: ${({ theme }) => theme.palette.primary.white};
  border-radius: ${({ theme }) => theme.borderRadius.m};
  display: flex;
`;
